<template>
  <div class="challenge-report">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <challenge-report-tab @clickedTab="selectedTab" :challengeSubType="getChallengeSubTypeValue"></challenge-report-tab>
      <!-- This component only contains Group Course Filter -->
      <!-- <report-group-course-filter-bar @selectedGroupObj="setGroupCourseObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag" v-if="currentSelectedTab === 4"></report-group-course-filter-bar> -->
      <!-- This component only contains Group Course and Cohort Filter -->
      <report-filter-bar-sub-type @selectedSubType="setSelectedSubType"></report-filter-bar-sub-type>
      <report-filter-bar @selectedGroupObj="setGroupCourseObj" @selectedCohortObj="setCohortObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag" v-if="currentSelectedTab === 1 || currentSelectedTab === 4"></report-filter-bar>
      <!-- This component only contains Group Course and Cohort and User Filter -->
      <report-group-course-cohort-user-filter-bar @selectedUserObj="setUserObj" @selectedGroupObj="setGroupCourseObj" @selectedCohortObj="setCohortObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag" v-if="currentSelectedTab === 3"></report-group-course-cohort-user-filter-bar>
      <!-- This component only contains Group Course and Cohort and Start and End date Filter -->
      <report-start-end-date-filter-bar @selectedEndDate="setEndDate" @selectedStartDate="setStartDate" @selectedGroupObj="setGroupCourseObj" @selectedCohortObj="setCohortObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag" v-if="currentSelectedTab === 2"></report-start-end-date-filter-bar>
      <hr width="94%" size="10px">
      <div class="row" v-if="showInfoTextToUser">
        <div class="col-md-12 col-lg-12 font-size-12px font-color-dark-red margin-bottom-1Perc" v-if="parseInt(this.currentSelectedTab) !== 2">
           {{setInfoText()}}
        </div>  
      </div>
      <div class="row margin-Top-2Perc">
        <div class="col-md-12 col-lg-12 width-97Point4Perc margin-left-1point5Perc">
          <sortable-list v-if="showchallengeReportList" v-bind:responseObj="getChallengeArrResp" v-bind:sortableColumnName="sortColumnNames" v-bind:columnNameToShow="columnNameToShow" v-bind:linkColumnName="linkColumnNames" v-bind:selectedsubOption="selectedsubOption" v-bind:colspanArr="colspanArr"></sortable-list>
        </div>
      </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
    </div>
    <error-page v-if="isUserGroupAdmin"></error-page>
  </div>  
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import ReportFilterBar from '@/components/ReportFilterBar'
import ReportGroupCourseFilterBar from '@/components/ReportGroupCourseFilterBar'
import ReportGroupCourseCohortUserFilterBar from '@/components/ReportGroupCourseCohortUserFilterBar'
import ReportStartEndDateFilterBar from '@/components/ReportStartEndDateFilterBar'
import { trackerService } from '@/server-util/tracker-service'
import { constants } from '@/utils/constants'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import CopyrightElement from '@/components/CopyrightElement'
import ChallengeReportTab from '@/components/ChallengeReportTab'
import csvHelper from '@/utils/csv-helper'
import list from '@/pages/SortableList'
import AlertBox from '@/components/AlertOverlay'
import { reportService } from '@/server-util/report-service'
import find from 'lodash/find'
import groupBy from 'lodash/groupBy'
import chain from 'lodash/chain'
import toPairs from 'lodash/toPairs'
import zipObject from 'lodash/zipObject'
import uniq from 'lodash/uniq'
import map from 'lodash/map'
import ErrorPage from '@/pages/Error'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment-timezone'
import ReportFilterBarSubType from '@/components/ReportFilterBarSubType'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      selectedGroupObj: null,
      selectedCohortObj: null,
      selectedUserObj: null,
      showExportButton: true,
      errorMsg: '',
      showSpinner: false,
      showAlertDialog: false,
      challengeRespArr: [],
      showchallengeReportList: false,
      sortColumnNames: ['Participant', 'VideosWatched', 'TotalVideos', 'AvgDeepDiveViews'],
      columnAlias: ['Participant', 'Videos Watched', 'Total Videos', 'Avg. DeepDive Views'],
      columnRespKey: ['Participant', 'VideosWatched', 'TotalVideos', 'AvgDeepDiveViews'],
      colspanArr: [],
      columnNameToShow: [],
      linkColumnNames: ['Comments', 'Likes'],
      isExportBtnClicked: false,
      isViewBtnClicked: false,
      csvFileName: 'ParticipantProgress Report',
      currentSelectedTab: 1,
      skillAssServerResp: [],
      progressSummnaryResp: [],
      participantProgress: [],
      prevUserId: '',
      startDate: '',
      endDate: '',
      selectedsubOption: 2,
      showInfoTextToUser: false,
      challengeSubType: 0
    }
  },
  components: {
    'report-filter-bar': ReportFilterBar,
    'challenge-report-tab': ChallengeReportTab,
    'Copyright-Element': CopyrightElement,
    'report-group-course-filter-bar': ReportGroupCourseFilterBar,
    'sortable-list': list,
    'alert-box': AlertBox,
    'report-group-course-cohort-user-filter-bar': ReportGroupCourseCohortUserFilterBar,
    'report-start-end-date-filter-bar': ReportStartEndDateFilterBar,
    'error-page': ErrorPage,
    'loader': Loader,
    'report-filter-bar-sub-type': ReportFilterBarSubType
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    trackPageLoad () {
      var store = this.$store
      var accessToken = store.state.access_token
      var userData = store.state.curr_user
      var userDataForActivity = 'UserName:{0}, FullName: {1}'
      userDataForActivity = userDataForActivity.replace('{0}', userData.UserName)
      userDataForActivity = userDataForActivity.replace('{1}', userData.FirstName + ' ' + userData.LastName)
      var trackingObj = {
        ActivityData: 'Load Discussions Page, ' + userDataForActivity,
        ActivityType: constants.AdminActivityType.Discussions,
        AdminAction: constants.AdminActionType.LoadScreen,
        ScreenName: 'DISCUSSIONS',
        UserRole: store.state.curr_user.AccountType,
        IsPrivate: false
      }
      trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
        if (responseObj3.status === 200) {
          console.log('LOGGED ACTIVITY : ')
        }
      })
    },
    selectedTab (value) {
      if (this.currentSelectedTab !== parseInt(value)) {
        // AK: If user changed Tab then do not show list and reset view and export btn flag to false
        this.showchallengeReportList = false
        this.showInfoTextToUser = false
        this.isViewBtnClicked = false
        this.isExportBtnClicked = false
      }
      // AK: To know which tab is clicked and Used to render different Challenge Title one Sortable Component
      this.currentSelectedTab = parseInt(value)
      switch (this.currentSelectedTab) {
        case 1:
          this.selectedsubOption = parseInt(constants.ReportSubOptionEnum.Challenges_Participant_Progress)
          if (!isEmpty(this.$store.state.selectedGroupCourseObj) && !isEmpty(this.$store.state.selectedCohortObj)) {
            this.updateViewBtnClickedFlag(true)
          }
          break
        case 2:
          this.selectedsubOption = parseInt(constants.ReportSubOptionEnum.Challenges_Progress_Summary)
          if (!isEmpty(this.$store.state.selectedGroupCourseObj) && !isEmpty(this.$store.state.selectedCohortObj)) {
            this.startDate = moment().tz('America/New_York').add(-7, 'days').format('MM/DD/YYYY')
            this.endDate = moment().tz('America/New_York').format('MM/DD/YYYY')
            this.updateViewBtnClickedFlag(true)
          }
          break
        case 3:
          this.selectedsubOption = parseInt(constants.ReportSubOptionEnum.Challenges_Participant_Progress_Quant)
          this.sortColumnNames = ['Challenges', 'Total']
          break
        case 4:
          this.selectedsubOption = parseInt(constants.ReportSubOptionEnum.Challenges_Participant_Progress_Quant)
          this.sortColumnNames = ['ResponseSubmitted', 'FeedbackGiven', 'FeedbackReviewed', 'VideoResponseCount', 'AudioResponseCount', 'TextResponseCount', 'VideoResponsePercentage', 'AudioResponsePercentage', 'TextResponsePercentage']
          if (!isEmpty(this.$store.state.selectedGroupCourseObj) && !isEmpty(this.$store.state.selectedCohortObj)) {
            this.updateViewBtnClickedFlag(true)
          }
          break
      }
    },
    setStartDate (value) {
      // AK: When user selected startDate then update it in parent file too
      this.startDate = value
    },
    setEndDate (value) {
      // AK: When user selected endDate then update it in parent file too
      this.endDate = value
    },
    setSelectedSubType (value) {
      // AK: When user selected particular challenge sub type then update it in parent file too
      this.challengeSubType = value
      console.log('Selected SubType: ' + this.challengeSubType)
    },
    setGroupCourseObj (value) {
      // AK: When user selected particular group object then update it in parent file too
      this.selectedGroupCourseObj = value
    },
    setCohortObj (value) {
      // AK: When user selected particular cohort object then update it in parent file too
      this.selectedCohortObj = value
    },
    setUserObj (value) {
      // AK: When user selected particular User object then update it in parent file too
      this.selectedUserObj = value
    },
    updateViewBtnClickedFlag (value) {
      this.isViewBtnClicked = value
      if (value) {
        // this.bindColumnsNameAndAlias()
        switch (this.currentSelectedTab) {
          case 1:
            this.csvFileName = 'ParticipantProgressReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
            this.getParticipantProgressReport()
            break
          case 2:
            this.csvFileName = 'ParticipantProgressSummaryReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
            this.getProgressSummaryReport()
            break
          case 3:
            this.csvFileName = 'ParticipantSkillAssessmentReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
            this.getSkillAssessmentReport()
            break
          case 4:
            this.csvFileName = 'ParticipantProgressQuantReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
            this.getParticipantProgressQuantReport()
            break
        }
      }
    },
    exportCSV (value) {
      this.isExportBtnClicked = value
      if (value) {
        // this.bindColumnsNameAndAlias()
        switch (this.currentSelectedTab) {
          case 1:
            // AK: This file will directly downloaded from server
            this.csvFileName = 'ParticipantProgressReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
            this.getParticipantProgressCSVReport()
            break
          case 2:
            // AK: This file will directly downloaded from server
            this.csvFileName = 'ParticipantProgressSummaryReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
            this.getProgressSummaryCSVReport()
            break
          case 3:
            this.csvFileName = 'ParticipantSkillAssessmentReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
            this.getSkillAssessmentReport()
            break
          case 4:
            this.csvFileName = 'ParticipantProgressQuantReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
            this.getParticipantProgressQuantReport()
            break
        }
      }
    },
    bindColumnsNameAndAlias: function () {
      this.columnNameToShow = []
      for (var i = 0; i < this.columnRespKey.length; i++) {
        var obj = {
          ColumnName: this.columnRespKey[i],
          ColumnAlias: this.columnAlias[i]
        }
        this.columnNameToShow.push(obj)
      }
      this.processAndExecuteSelectedOperation()
      // console.log('Column And alias Name Obj >>>> ' + JSON.stringify(this.columnNameToShow))
    },
    getParticipantProgressQuantReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj.CohortId !== null || this.selectedCohortObj.CohortId !== undefined || this.selectedCohortObj.CohortId !== '') {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getChallengeParticipantProgressQuantData(storeObj.state.access_token, _this.selectedCohortObj.CohortId, _this.challengeSubType).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.challengeRespArr = responseObj.data
              if (parseInt(_this.challengeRespArr.length) === 0) {
                this.showAlertDialog = true
                // var subCourseTitle = this.selectedGroupCourseObj.CourseSubTitle !== null && this.selectedGroupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + this.selectedGroupCourseObj.CourseSubTitle + ']' : ''
                this.errorMsg = 'No report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showchallengeReportList = false
              } else {
                // this.processAndExecuteSelectedOperation()
                this.addColumnAlias()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('GroupCourseMasterId is NULL hence declined LOADING Participant Progress Quant LIST')
      }
    },
    getSkillAssessmentReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj !== null && this.selectedUserObj !== null) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getChallengeSkillAssessmentData(storeObj.state.access_token, _this.selectedUserObj.UserId, _this.selectedCohortObj.CohortId, _this.challengeSubType).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.skillAssServerResp = responseObj.data
              // console.log('getSkillAssessmentReport >>> ' + JSON.stringify(_this.skillAssServerResp))
              if (_this.skillAssServerResp.SkillList === null || _this.skillAssServerResp.ReportData === null) {
                this.showAlertDialog = true
                this.errorMsg = 'No report found for \'' + this.selectedUserObj.FirstName + ' ' + this.selectedUserObj.LastName + '\'.'
                this.showchallengeReportList = false
              } else {
                this.addColumnAlias()
                // AK: If prev selected User id is not same then re-bind everything
                /* if (this.prevUserId !== this.selectedUserObj.UserId) {
                  this.prevUserId = this.selectedUserObj.UserId
                  this.addColumnAlias()
                } else {
                  // AK: If Obj is re-binded already then process next
                  this.processAndExecuteSelectedOperation()
                } */
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('COHORT ID OR User ID is NULL hence declined LOADING Skill Assessment LIST')
      }
    },
    addColumnAlias: function () {
      this.columnAlias = []
      switch (this.currentSelectedTab) {
        case 1:
          var result = chain(this.participantProgress)
          result = groupBy(this.participantProgress.ChallengesInfo, 'ReleaseTS')
          result = toPairs(result)
          result = map(result, (currentItem) => {
            return zipObject(['ReleaseTS', 'ChallengesInfo'], currentItem)
          })
          // console.log('Map >>>> ' + JSON.stringify(result))
          this.colspanArr = []
          for (var ii = 0; ii < result.length; ii++) {
            var challItem = result[ii]
            this.colspanArr.push({
              ReleaseTS: 'Release Date - ' + dmAdminUtils.getMonthInWordFromDate(dmAdminUtils.covertUtcToEstWithoutTime(challItem.ReleaseTS)),
              ColSpan: challItem.ChallengesInfo.length * 5
            })
          }
          // AK: Get unique released dates
          var uniqueReleaseDates = uniq(map(this.participantProgress.ChallengesInfo, 'ReleaseTS'))
          for (var j = 0; j < uniqueReleaseDates.length; j++) {
            this.columnAlias.push('Release Date - ' + dmAdminUtils.getMonthInWordFromDate(dmAdminUtils.covertUtcToEstWithoutTime(uniqueReleaseDates[j])))
          }
          // AK: For participant name list
          this.columnAlias.push('Users')
          for (var i = 0; i < this.participantProgress.ChallengesInfo.length; i++) {
            var prefixToAdd = 'Challenge '
            if (parseInt(this.challengeSubType) === parseInt(constants.DescVideoType.Teachback)) {
              prefixToAdd = 'Teachback '
            }
            this.columnAlias.push(prefixToAdd + (i + 1) + ': ' + this.participantProgress.ChallengesInfo[i].ChallengeTitle)
            this.columnAlias.push('Type')
            this.columnAlias.push('Response Submitted')
            this.columnAlias.push('Feedback Given')
            this.columnAlias.push('# of Feedback Given')
            this.columnAlias.push('Feedback given to')
            this.columnAlias.push('Feedback Received')
            this.columnAlias.push('Feedback Reviewed')
            this.columnAlias.push('Avg. P2P Score')
            this.columnAlias.push('Avg. Skills Score')
            this.columnAlias.push('# of Peers assigned')
            this.columnAlias.push('Allocated to')
            this.columnAlias.push('Response DateTime')
            this.columnAlias.push('Feedback Allocation Time')
            this.columnAlias.push('Feedback From')
            this.columnAlias.push('Allowed Response Types')
            this.columnAlias.push('Response Type')
          }
          this.columnAlias.push('Total #challenges responded to')
          break
        case 2:
          this.columnAlias = ['Date']
          for (i = 0; i < this.progressSummnaryResp.ChallengesInfo.length; i++) {
            prefixToAdd = 'Challenge '
            if (parseInt(this.challengeSubType) === parseInt(constants.DescVideoType.Teachback)) {
              prefixToAdd = 'Teachback '
            }
            this.columnAlias.push(prefixToAdd + (i + 1) + ':' + this.progressSummnaryResp.ChallengesInfo[i].ChallengeTitle)
            this.columnAlias.push('Response Submitted')
            this.columnAlias.push('Feedback Given')
            this.columnAlias.push('Feedback Reviewed')
          }
          break
        case 3:
          if (parseInt(this.challengeSubType) === parseInt(constants.DescVideoType.Teachback)) {
            this.columnAlias = ['Teachback']
          } else {
            this.columnAlias = ['Challenges']
          }
          for (i = 0; i < this.skillAssServerResp.SkillList.length; i++) {
            this.columnAlias.push(this.skillAssServerResp.SkillList[i])
          }
          this.columnAlias.push('Grand Total')
          break
        case 4:
          if (parseInt(this.challengeSubType) === parseInt(constants.DescVideoType.Teachback)) {
            this.columnAlias = ['Teachback', 'Type', 'Response Submitted', 'Feedback Given - by Peers', 'Feedback Given - by Coach', 'Feedback Received', 'Feedback Reviewed', 'Allowed Types', 'Video #', 'Audio #', 'Text #', 'Video %', 'Audio %', 'Text %']
          } else {
            this.columnAlias = ['Challenges', 'Type', 'Response Submitted', 'Feedback Given - by Peers', 'Feedback Given - by Coach', 'Feedback Received', 'Feedback Reviewed', 'Allowed Types', 'Video #', 'Audio #', 'Text #', 'Video %', 'Audio %', 'Text %']
          }
          break
      }
      // console.log('this.columnAlias >>>> ' + JSON.stringify(this.columnAlias))
      this.addColumnRespKey()
    },
    addColumnRespKey: function () {
      this.columnRespKey = []
      switch (this.currentSelectedTab) {
        case 1:
          // AK: Get unique released dates
          var uniqueReleaseDates = uniq(map(this.participantProgress.ChallengesInfo, 'ReleaseTS'))
          for (var j = 0; j < uniqueReleaseDates.length; j++) {
            this.columnRespKey.push('')
          }
          // AK: For participant name list
          this.columnRespKey.push('UserFullName')
          for (var i = 0; i < this.participantProgress.ChallengesInfo.length; i++) {
            this.columnRespKey.push('')
            this.columnRespKey.push('Challenge Type_' + [i])
            this.columnRespKey.push('Response Submitted_' + [i])
            this.columnRespKey.push('Feedback Given_' + [i])
            this.columnRespKey.push('Feedback Given Count_' + [i])
            this.columnRespKey.push('Feedback Given To_' + [i])
            this.columnRespKey.push('Feedback Received_' + [i])
            this.columnRespKey.push('Feedback Reviewed_' + [i])
            this.columnRespKey.push('Avg P2P Score_' + [i])
            this.columnRespKey.push('Avg Skills Score_' + [i])
            this.columnRespKey.push('Peer Assigned_' + [i])
            this.columnRespKey.push('Assigned Peer Names_' + [i])
            this.columnRespKey.push('Submission TS_' + [i])
            this.columnRespKey.push('Feedback Allocation Time_' + [i])
            this.columnRespKey.push('Feedback From_' + [i])
            this.columnRespKey.push('Allowed Response Type_' + [i])
            this.columnRespKey.push('Response Type_' + [i])
          }
          this.columnRespKey.push('TotalResponseSubmitted')
          break
        case 2:
          this.columnRespKey = ['Date']
          for (i = 0; i < this.progressSummnaryResp.ChallengesInfo.length; i++) {
            this.columnRespKey.push('')
            this.columnRespKey.push('Response Submitted_' + [i])
            this.columnRespKey.push('Feedback Given_' + [i])
            this.columnRespKey.push('Feedback Reviewed_' + [i])
          }
          break
        case 3:
          this.columnRespKey = ['Challenges']
          for (i = 0; i < this.skillAssServerResp.SkillList.length; i++) {
            this.columnRespKey.push('SkillList_' + [i])
          }
          this.columnRespKey.push('Total')
          break
        case 4:
          this.columnRespKey = ['ChallengeTitle', 'ChallengeType', 'ResponseSubmitted', 'FeedbackGiven', 'FeedbackGivenByCoach', 'FeedbackReceived', 'FeedbackReviewed', 'AllowedResponseType', 'VideoResponseCount', 'AudioResponseCount', 'TextResponseCount', 'VideoResponsePercentage', 'AudioResponsePercentage', 'TextResponsePercentage']
          break
      }
      // console.log('this.columnRespKey >>>> ' + JSON.stringify(this.columnRespKey))
      this.bindResponseObj()
    },
    bindResponseObj: function () {
      this.responseToPass = []
      //  var _this = this
      // AK: Itrate Loop till max number of rows
      switch (this.currentSelectedTab) {
        case 1:
          for (var i = 0; i < this.participantProgress.ProgressInfo.length; i++) {
            this.responseToPass.push(this.filterAndGetParticipantProgressData(this.participantProgress.ProgressInfo[i]))
          }
          this.challengeRespArr = this.responseToPass
          break
        case 2:
          for (i = 0; i < this.progressSummnaryResp.ProgressData.length; i++) {
            this.responseToPass.push(this.filterAndGetData(this.progressSummnaryResp.ProgressData[i]))
          }
          this.challengeRespArr = this.responseToPass
          break
        case 3:
          for (i = 0; i < this.skillAssServerResp.ReportData.length; i++) {
            // AK: Create obj and assign defaults values
            var obj = {
              Challenges: this.skillAssServerResp.ReportData[i].ChallengeTitle,
              Total: this.skillAssServerResp.ReportData[i].GrandTotal
            }
            for (var j = 0; j < this.skillAssServerResp.SkillList.length; j++) {
              var skillName = this.skillAssServerResp.SkillList[j]
              var userSkill = find(this.skillAssServerResp.ReportData[i].SkillData, {SkillName: skillName})
              if (userSkill) {
                obj['SkillList_' + j] = userSkill.Score
              } else {
                obj['SkillList_' + j] = ''
              }
            }
            this.responseToPass.push(obj)
          }
          this.challengeRespArr = this.responseToPass
          break
      }
      // console.log('this.responseToPass >>>> ' + JSON.stringify(this.responseToPass))
      this.bindColumnsNameAndAlias()
    },
    filterAndGetData (progressData) {
      // console.log('RPT DATA OJ : ' + JSON.stringify(progressData))
      var obj = {}
      obj['Date'] = dmAdminUtils.getMonthInWordFromDate(progressData.ProgressDate)
      var displayedIds = []
      for (var j = 0; j < progressData.ChallengesProgressInfo.length; j++) {
        for (var i = 0; i < this.progressSummnaryResp.ChallengesInfo.length; i++) {
          var challInfo = this.progressSummnaryResp.ChallengesInfo[i]
          if (challInfo.ChallengeId === progressData.ChallengesProgressInfo[j].ChallengeId) {
            obj['Response Submitted_' + [i]] = progressData.ChallengesProgressInfo[j].ResponseSubmitted
            obj['Feedback Given_' + [i]] = progressData.ChallengesProgressInfo[j].FeedbackGiven
            obj['Feedback Reviewed_' + [i]] = progressData.ChallengesProgressInfo[j].FeedbackReviewed
            displayedIds.push(challInfo.ChallengeId)
          } else {
            if (displayedIds.indexOf(challInfo.ChallengeId) === -1) {
              obj['Response Submitted_' + [i]] = 'N/A'
              obj['Feedback Given_' + [i]] = 'N/A'
              obj['Feedback Reviewed_' + [i]] = 'N/A'
            }
          }
        }
      }
      return obj
    },
    filterAndGetParticipantProgressData (progressInfo) {
      // console.log('RPT DATA OJ : ' + JSON.stringify(progressInfo))
      var obj = {}
      obj['UserFullName'] = progressInfo.UserFullName
      var displayedIds = []
      for (var j = 0; j < progressInfo.UserChallengeProgressInfo.length; j++) {
        for (var i = 0; i < this.participantProgress.ChallengesInfo.length; i++) {
          var challInfo = this.participantProgress.ChallengesInfo[i]
          if (challInfo.ChallengeId === progressInfo.UserChallengeProgressInfo[j].ChallengeId) {
            obj['Challenge Type_' + [i]] = progressInfo.UserChallengeProgressInfo[j].ChallengeType !== null ? progressInfo.UserChallengeProgressInfo[j].ChallengeType : 'N/A'
            obj['Response Submitted_' + [i]] = parseInt(progressInfo.UserChallengeProgressInfo[j].ResponseSubmitted) > 0 ? 'Yes' : 'No'
            obj['Feedback Given_' + [i]] = parseInt(progressInfo.UserChallengeProgressInfo[j].FeedbackGiven) > 0 ? 'Yes' : 'No'
            obj['Feedback Given Count_' + [i]] = parseInt(progressInfo.UserChallengeProgressInfo[j].FeedbackGivenCount)
            obj['Feedback Given To_' + [i]] = progressInfo.UserChallengeProgressInfo[j].FeedbackGivenTo !== null ? progressInfo.UserChallengeProgressInfo[j].FeedbackGivenTo : 'N/A'
            obj['Feedback Received_' + [i]] = progressInfo.UserChallengeProgressInfo[j].FeedbackReceived !== null ? progressInfo.UserChallengeProgressInfo[j].FeedbackReceived > 0 ? 'Yes' : 'No' : 'N/A'
            obj['Feedback Reviewed_' + [i]] = parseInt(progressInfo.UserChallengeProgressInfo[j].FeedbackReviewed) > 0 ? 'Yes' : 'No'
            obj['Avg P2P Score_' + [i]] = progressInfo.UserChallengeProgressInfo[j].AvgP2PScore
            obj['Avg Skills Score_' + [i]] = progressInfo.UserChallengeProgressInfo[j].AvgSkillsScore
            obj['Peer Assigned_' + [i]] = progressInfo.UserChallengeProgressInfo[j].PeersAssigned
            obj['Assigned Peer Names_' + [i]] = progressInfo.UserChallengeProgressInfo[j].AssignedPeerNames
            obj['Submission TS_' + [i]] = progressInfo.UserChallengeProgressInfo[j].SubmissionTS !== null ? dmAdminUtils.formatDateAndTimeWithOutTimeZone(progressInfo.UserChallengeProgressInfo[j].SubmissionTS) : 'N/A'
            obj['Feedback Allocation Time_' + [i]] = progressInfo.UserChallengeProgressInfo[j].FeedbackAllocationTime !== null ? progressInfo.UserChallengeProgressInfo[j].FeedbackAllocationTime : 'N/A'
            obj['Feedback From_' + [i]] = progressInfo.UserChallengeProgressInfo[j].FeedbackFrom !== null ? progressInfo.UserChallengeProgressInfo[j].FeedbackFrom : 'N/A'
            obj['Allowed Response Type_' + [i]] = progressInfo.UserChallengeProgressInfo[j].AllowedResponseType !== null ? progressInfo.UserChallengeProgressInfo[j].AllowedResponseType : 'N/A'
            obj['Response Type_' + [i]] = progressInfo.UserChallengeProgressInfo[j].ResponseType !== null ? progressInfo.UserChallengeProgressInfo[j].ResponseType : 'N/A'
            displayedIds.push(challInfo.ChallengeId)
          } else {
            if (displayedIds.indexOf(challInfo.ChallengeId) === -1) {
              obj['Challenge Type_' + [i]] = 'N/A'
              obj['Response Submitted_' + [i]] = 'N/A'
              obj['Feedback Given_' + [i]] = 'N/A'
              obj['Feedback Given Count_' + [i]] = 'N/A'
              obj['Feedback Given To_' + [i]] = 'N/A'
              obj['Feedback Received_' + [i]] = 'N/A'
              obj['Feedback Reviewed_' + [i]] = 'N/A'
              obj['Avg P2P Score_' + [i]] = 'N/A'
              obj['Avg Skills Score_' + [i]] = 'N/A'
              obj['Peer Assigned_' + [i]] = 'N/A'
              obj['Assigned Peer Names_' + [i]] = 'N/A'
              obj['Submission TS_' + [i]] = 'N/A'
              obj['Feedback Allocation Time_' + [i]] = 'N/A'
              obj['Feedback From_' + [i]] = 'N/A'
              obj['Allowed Response Type_' + [i]] = 'N/A'
              obj['Response Type_' + [i]] = 'N/A'
            }
          }
        }
      }
      // console.log(progressInfo.TotalResponseSubmitted)
      obj['TotalResponseSubmitted'] = progressInfo.TotalResponseSubmitted
      return obj
    },
    processAndExecuteSelectedOperation: function () {
      this.showInfoTextToUser = true
      if ((!this.isExportBtnClicked) && this.isViewBtnClicked) {
        // AK: If export btn not clicked and list is shown previously then show list only
        this.showchallengeReportList = true
      } else if (this.isExportBtnClicked && (!this.isViewBtnClicked)) {
        // AK: If user directly clicked on export button without clicking view first then export data
        this.exportData()
      } else if (this.isExportBtnClicked && this.isViewBtnClicked) {
        // AK: If user performed both operations then performed both operations
        this.showchallengeReportList = true
        this.exportData()
      }
    },
    exportData: function () {
      return csvHelper.export(this.getChallengeArrResp, this.columnRespKey, this.columnAlias, this.csvFileName)
    },
    getProgressSummaryReport: function () {
      var storeObj = this.$store
      var _this = this
      if (Date.parse(this.startDate) > Date.parse(this.endDate)) {
        this.showAlertDialog = true
        this.errorMsg = 'Start date must be less than the end date.'
        return
      }
      if (this.selectedCohortObj !== null) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getChallengeParticipantProgressSummary(storeObj.state.access_token, _this.selectedCohortObj.CohortId, _this.startDate, _this.endDate, _this.challengeSubType).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.progressSummnaryResp = responseObj.data
              // console.log('getProgressSummaryReport >>> ' + JSON.stringify(_this.progressSummnaryResp))
              if (_this.progressSummnaryResp.ChallengesInfo.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No report found for \'' + this.selectedCohortObj.CohortName + '\' cohort in a selected interval period.'
                // this.errorMsg = 'No report found for \'' + this.selectedGroupCourseObj.GroupName + '::' + this.selectedGroupCourseObj.CourseTitle + '\' in a selected interval period.'
                this.showchallengeReportList = false
              } else {
                this.addColumnAlias()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('COHORT ID OR START and END DATE is NULL hence declined LOADING Progress Summary LIST')
      }
    },
    getProgressSummaryCSVReport: function () {
      var storeObj = this.$store
      var _this = this
      if (Date.parse(this.startDate) > Date.parse(this.endDate)) {
        this.showAlertDialog = true
        this.errorMsg = 'Start date must be less than the end date.'
        return
      }
      if (this.selectedCohortObj !== null) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getChallengeParticipantProgressSummaryForCSV(storeObj.state.access_token, _this.selectedCohortObj.CohortId, _this.startDate, _this.endDate, _this.challengeSubType).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showInfoTextToUser = true
              return csvHelper.exportFromServerData(responseObj.data, this.csvFileName)
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('COHORT ID OR START and END DATE is NULL hence declined LOADING Progress Summary LIST')
      }
    },
    getParticipantProgressReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj !== null) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getChallengeParticipantProgressData(storeObj.state.access_token, _this.selectedCohortObj.CohortId, _this.challengeSubType).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.participantProgress = responseObj.data
              if (_this.participantProgress.ChallengesInfo.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showchallengeReportList = false
              } else {
                this.addColumnAlias()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('COHORT ID OR START and END DATE is NULL hence declined LOADING Participant Progress LIST')
      }
    },
    getParticipantProgressCSVReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj !== null) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getChallengeParticipantProgressDataForCSV(storeObj.state.access_token, _this.selectedCohortObj.CohortId, _this.challengeSubType).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showInfoTextToUser = true
              return csvHelper.exportFromServerData(responseObj.data, this.csvFileName)
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('COHORT ID OR START and END DATE is NULL hence declined LOADING Participant Progress LIST')
      }
    },
    setInfoText: function () {
      var getNextDate = dmAdminUtils.getStartOfNextEstDay()
      if ((!this.isExportBtnClicked) && this.isViewBtnClicked) {
        return 'Below data gets generated once every day. If you do not see the data, please come back after ' + getNextDate + ' and check again.'
      } else if (this.isExportBtnClicked && (!this.isViewBtnClicked)) {
        return 'Downloaded data gets generated once every day. If you do not see the data please come back after ' + getNextDate + ' and check again.'
      } else if (this.isExportBtnClicked && this.isViewBtnClicked) {
        return 'Below data gets generated once every day. If you do not see the data, please come back after ' + getNextDate + ' and check again.'
      }
    }
  },
  computed: {
    getChallengeSubTypeValue: {
      get: function () {
        return this.challengeSubType
      }
    },
    getChallengeArrResp: {
      get: function () {
        return this.challengeRespArr
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'challenge-report'
}
</script>

<style scoped>
.challenge-report {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
/* Using Only for footer */
.footer{
    /* position: fixed; */
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.margin-left-1point5Perc{
  margin-left:1.5% !important;
}
.width-97Point4Perc{
  width:97.4% !important; 
}
.font-size-12px {
  font-size: 12px !important;
}
.font-color-dark-red {
  color: darkred;
}
.margin-bottom-1Perc{
  margin-bottom:1% !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/ChallengeReport.vue